import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import contentBlockConfig from 'constants/contentBlockConfig';
const ImpactCategory = styled.div `
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  display: flex;
  align-items: center;
  grid-gap: 8px;
  margin: 16px 0 16px 16px;
  min-height: 23px;

  svg {
    width: 22px;
    height: 20px;
  }
`;
const ImpactClaimCategoryColored = ({ impactClaim, }) => {
    var _a;
    const categoryName = impactClaim === null || impactClaim === void 0 ? void 0 : impactClaim.impactCatalogItem.category.type;
    const { t } = useTranslation();
    const Icon = (_a = contentBlockConfig['ImpactClaims']) === null || _a === void 0 ? void 0 : _a.icon;
    return (React.createElement(ImpactCategory, null,
        Icon && React.createElement(Icon, { color: "ffffff" }),
        React.createElement("span", null, categoryName && t(`impact-claims.category-title.${categoryName}`))));
};
export default ImpactClaimCategoryColored;
